<div class=" hidden-md hidden-lg ">
  <app-nav ></app-nav>
  </div>
    <div class="visible-lg visible-md">
      <app-headermain> </app-headermain>
  </div>

<div class="account-layout ">

  <!-- Sidebar -->
  <div class="account-sidebar">
    <app-account-header [activeTab]="activeTab" (scrollToSection)="scrollTo($event)">
    </app-account-header>
  </div>

  <!-- Main content -->
  <div class="account-main">

    <!-- Page header — only on profile/login/devices -->
    <div class="account-page-header" *ngIf="activeTab!=='trips'">
      <div class="account-page-header-left">
        <p class="account-page-label">My Account</p>
        <h1 class="account-page-title">Hello, {{ user?.first_name || user?.fullName || 'traveller' }}.</h1>
        <p class="account-page-sub">Manage your profile, login details and connected devices in one place.</p>
      </div>
      <div class="account-page-header-actions">
        <button class="btn-danger-outline-action account-signout-action" type="button" (click)="logoutUser()">Sign out</button>
      </div>
    </div>

    <!-- Top cards row — only on profile/login/devices tabs -->
    <div class="account-cards-row" *ngIf="activeTab!=='trips'">

      <!-- Profile strength -->
      <div class="strength-card">
        <div class="strength-card-top">
          <div>
            <p class="strength-label">Profile completion</p>
            <p class="strength-number">{{ profileCompletion }}<span class="strength-percent">%</span></p>
          </div>
          <span class="strength-badge"
            [class.badge-danger]="profileCompletion < 40"
            [class.badge-warn]="profileCompletion >= 40 && profileCompletion < 80"
            [class.badge-good]="profileCompletion >= 80">
            {{ profileCompletion >= 80 ? 'Looking good!' : profileCompletion >= 40 ? 'Almost there' : 'Just started' }}
          </span>
        </div>
        <div class="strength-bar-track">
          <div class="strength-bar-fill"
            [style.width.%]="profileCompletion"
            [class.fill-danger]="profileCompletion < 40"
            [class.fill-warn]="profileCompletion >= 40 && profileCompletion < 80"
            [class.fill-good]="profileCompletion >= 80"></div>
        </div>
        <p class="strength-hint">
          @if (!form.id_number) { Add your ID number to reach 100% and unlock priority booking. }
          @else { Your profile is complete — enjoy priority booking! }
        </p>
      </div>

      <div class="account-summary-card">
        <p class="account-summary-label">Account snapshot</p>
        <h3 class="account-summary-title">{{ user?.fullName || user?.first_name || 'Traveller' }}</h3>
        <p class="account-summary-sub">Your key account details and quick actions in one place.</p>

        <div class="account-summary-grid">
          <div class="account-summary-item">
            <span class="account-summary-key">Mobile number</span>
            <span class="account-summary-value">{{ user?.phone_number || 'Not added yet' }}</span>
          </div>
          <div class="account-summary-item">
            <span class="account-summary-key">Email address</span>
            <span class="account-summary-value">{{ user?.email || 'Not added yet' }}</span>
          </div>
         
        </div>

        <div class="account-summary-actions">
          <button class="referral-copy-btn-secondary" type="button" data-toggle="modal" data-target="#buupassProfileModal">Edit profile</button>
          <button class="referral-copy-btn-secondary" type="button" (click)="scrollTo('login')">Login details</button>
        </div>
      </div>

    </div>

    <!-- ── TRIPS TAB ──────────────────────────────────── -->
    @if (activeTab === 'trips') {
      <div class="trips-header">
        <div>
          <p class="account-page-label">My Trips</p>
          <h1 class="trips-title">Your journeys.</h1>
          <p class="account-page-sub">Every booking, every receipt, every route — kept in one place.</p>
        </div>
        <div class="account-section-actions">
          <a href="/" class="btn-book-trip">+ Book a trip</a>
          <button class="btn-danger-outline-action account-signout-action" type="button" (click)="logoutUser()">Sign out</button>
        </div>
      </div>

      <div class="trips-filter-bar" style="margin-top: 24px;">
        <button class="filter-tab" [class.active]="filterTab==='upcoming'"  (click)="setFilter('upcoming')">
          Upcoming @if(upcomingCount>0){<span class="filter-count">{{upcomingCount}}</span>}
        </button>
        <button class="filter-tab" [class.active]="filterTab==='completed'" (click)="setFilter('completed')">
          Completed @if(completedCount>0){<span class="filter-count muted">{{completedCount}}</span>}
        </button>
        <button class="filter-tab" [class.active]="filterTab==='cancelled'" (click)="setFilter('cancelled')">
          Cancelled @if(cancelledCount>0){<span class="filter-count muted">{{cancelledCount}}</span>}
        </button>
      </div>

      @if (!flightTripsAvailable) {
        <div class="trips-empty trips-empty-unavailable">
          <div class="trips-empty-icon">✈️</div>
          <h3>Flight reservations are not available yet</h3>
          <p>We’re still connecting your account to flight reservation history. Once that is ready, your bookings will appear here.</p>
          <a href="/" class="btn-book-trip">Book a flight</a>
        </div>
      }
      @if (flightTripsAvailable && tripsLoading) {
        <div class="trips-loading"><img src="assets/img/gifs/rll.gif"><p>Loading your trips…</p></div>
      }
      @if (flightTripsAvailable && !tripsLoading && filteredTrips.length === 0) {
        <div class="trips-empty">
          <div class="trips-empty-icon">🚌</div>
          <h3>No {{ filterTab }} flight reservations yet</h3>
          <p>Book a flight and it will appear here.</p>
        </div>
      }
      @if (flightTripsAvailable && !tripsLoading && filteredTrips.length > 0) {
        <div class="trips-list">
          @for (trip of filteredTrips; track trip.booking_reference || $index) {
            <div class="trip-card" [class.expanded]="expandedIndex === $index">
              <div class="trip-summary" (click)="toggleExpand($index)">
                <div class="trip-date-block">
                  <span class="trip-day">{{ trip.departure_date | date:'dd' }}</span>
                  <span class="trip-month">{{ trip.departure_date | date:'MMM' | uppercase }}</span>
                </div>
                <div class="trip-route">
                  <div class="trip-time-row">
                    <span class="trip-time">{{ trip.departure_time || '—' }}</span>
                    <span class="trip-dash-line"></span>
                    <span class="trip-arrow-icon">→</span>
                    <span class="trip-time">{{ trip.arrival_time || '—' }}</span>
                  </div>
                  <div class="trip-cities-row">
                    <span class="trip-city">{{ trip.source || '—' }}</span>
                    <span class="trip-city-gap"></span>
                    <span class="trip-city">{{ trip.destination || '—' }}</span>
                  </div>
                  <div class="trip-route-meta-mobile">
                    <span class="trip-operator-mobile">{{ trip.operator || '—' }}</span>
                    @if (trip.seats?.[0]) { <span class="trip-seat-mobile">Seat {{ trip.seats[0] }}</span> }
                  </div>
                </div>
                <div class="trip-meta">
                  <span class="trip-operator">{{ trip.operator }}</span>
                  @if (trip.seats?.[0]) { <span class="trip-seat">Seat {{ trip.seats[0] }}</span> }
                </div>
                <div class="trip-right">
                  <span class="trip-status-badge"
                    [class.status-upcoming]="tripStatus(trip)==='Upcoming'"
                    [class.status-completed]="tripStatus(trip)==='Completed'"
                    [class.status-cancelled]="tripStatus(trip)==='Cancelled'">
                    {{ tripStatus(trip) }}
                  </span>
                  <span class="trip-price">Ksh {{ trip.total_amount | number }}</span>
                </div>
                <i class="fa trip-chevron" [class.fa-chevron-up]="expandedIndex===$index" [class.fa-chevron-down]="expandedIndex!==$index"></i>
              </div>
              @if (expandedIndex === $index) {
                <div class="trip-detail">
                  <div class="trip-detail-col"><p class="detail-label">Route</p><p class="detail-value">{{ trip.source || '—' }} - {{ trip.destination || '—' }}</p></div>
                  <div class="trip-detail-col"><p class="detail-label">Booking Ref</p><p class="detail-value">{{ trip.trade_id || '—' }}</p></div>
                  <div class="trip-detail-col"><p class="detail-label">Date</p><p class="detail-value">{{ trip.departure_date | date:'EEE, dd MMM yyyy' }}</p></div>
                  <div class="trip-detail-col"><p class="detail-label">Operator</p><p class="detail-value">{{ trip.operator || '—' }}</p></div>
                  <div class="trip-detail-col"><p class="detail-label">Seat</p><p class="detail-value">{{ trip.seats?.[0] || '—' }}</p></div>
                  <div class="trip-detail-col"><p class="detail-label">Passenger</p><p class="detail-value">{{ trip.passengers?.[0]?.full_name || '—' }}</p></div>
                  <div class="trip-detail-col"><p class="detail-label">Payment</p><p class="detail-value">{{ trip.payment_channel | titlecase }}</p></div>
                </div>
              }
            </div>
          }
        </div>
        <div class="trips-stats">
          <div class="trips-stat"><p class="trips-stat-label">Trips this year</p><p class="trips-stat-value">{{ trips.length }}</p></div>
          <div class="trips-stat"><p class="trips-stat-label">Total spent</p><p class="trips-stat-value">Ksh {{ totalSpent | number }}</p></div>
          <div class="trips-stat"><p class="trips-stat-label">Operators used</p><p class="trips-stat-value">{{ uniqueOperators }}</p></div>
        </div>
      }
    }

    <!-- Personal information -->
    @if (activeTab === 'profile') {
      <div class="info-section">
        <div class="info-section-header">
          <div>
            <h2 class="info-section-title">Personal information</h2>
            <p class="info-section-sub">Basic details for a faster booking experience</p>
          </div>
          <button class="btn-edit" data-toggle="modal" data-target="#buupassProfileModal">Edit</button>
        </div>
        <div class="info-row">
          <span class="info-key">First name</span>
          <span class="info-val">
            @if (user?.first_name) { {{ user.first_name }} }
            @else { <button class="add-link" data-toggle="modal" data-target="#buupassProfileModal">+ Add</button> }
          </span>
        </div>
        <div class="info-row">
          <span class="info-key">Last name</span>
          <span class="info-val">
            @if (user?.last_name) { {{ user.last_name }} }
            @else { <button class="add-link" data-toggle="modal" data-target="#buupassProfileModal">+ Add</button> }
          </span>
        </div>
        <div class="info-row">
          <span class="info-key">ID number</span>
          <span class="info-val">
            @if (user?.id_number) { {{ user.id_number | slice:0:5 }}***{{ user.id_number | slice:-1 }} }
            @else { <button class="add-link" data-toggle="modal" data-target="#buupassProfileModal">+ Add</button> }
          </span>
        </div>
      </div>
    }

    <!-- Login & security -->
    @if (activeTab === 'login') {
      <div class="info-section">
        <div class="info-section-header">
          <div>
            <h2 class="info-section-title">Login &amp; security</h2>
            <p class="info-section-sub">Manage how you access your account</p>
          </div>
        </div>
        <div class="info-row">
          <span class="info-key">Mobile number</span>
          <span class="info-val info-val-row">
            @if (user?.phone_number) {
              {{ user.phone_number }}
              <!-- <span class="status-badge verified">Verified</span> -->
            } @else {
              <button class="add-link" data-toggle="modal" data-target="#buupassPhoneModal">+ Add</button>
            }
          </span>
        </div>
        <div class="info-row">
          <span class="info-key">Email address</span>
          <span class="info-val info-val-row">
            @if (user?.email) {
              {{ user.email }}
              <!-- <span class="status-badge pending">Pending</span> -->
            } @else {
              <button class="add-link" data-toggle="modal" data-target="#buupassEmailModal">+ Add</button>
            }
          </span>
        </div>
        <div class="info-row">
          <span class="info-key">Password</span>
          <span class="info-val">
            <button class="change-link" data-toggle="modal" data-target="#buupassPasswordModal">Change password</button>
          </span>
        </div>
      </div>
    }

    <!-- Devices -->
    @if (activeTab === 'devices') {
      <div class="info-section">
        <div class="info-section-header">
          <div>
            <h2 class="info-section-title">Devices</h2>
            <p class="info-section-sub">Check all the devices where your account is logged in</p>
          </div>
        </div>
        @if (loggedInDevices?.length > 0) {
          @for (device of loggedInDevices; track device) {
            <div class="info-row device-row">
              <div>
                <p class="device-name">{{ device.deviceType }}</p>
                <p class="device-meta">{{ device.location }} · {{ device.ipAddress }}</p>
                <p class="device-meta">Last active: {{ device.lastActive }}</p>
              </div>
              @if (device.isCurrent) {
                <span class="status-badge verified">Current device</span>
              }
            </div>
          }
        } @else {
          <p class="info-empty">No devices found.</p>
        }
      </div>
    }

  </div>

</div>

<!-- ── Modals (unchanged logic) ───────────────────────── -->

<!-- Data Export Modal -->
<div
  class="modal fade"
  id="buupassDataExportModal"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
  aria-labelledby="buupassDataExportModalTitle"
  [class.show]="isDataExportModalOpen"
  [style.display]="isDataExportModalOpen ? 'block' : 'none'"
  [attr.aria-hidden]="isDataExportModalOpen ? null : 'true'"
  (click)="closeDataExportModal()"
  (keydown.escape)="closeDataExportModal()">
  <div class="modal-dialog modal-dialog-centered modal-lg" (click)="$event.stopPropagation()">
    <div class="modal-content rounded-3 export-modal">
      <div class="modal-header export-modal-header">
        <div>
          <p class="export-modal-kicker">Download your data</p>
          <h5 class="modal-title export-modal-title" id="buupassDataExportModalTitle">Export preview</h5>
          <p class="export-modal-sub">This export downloads as JSON and includes only the useful account information, not raw page state.</p>
        </div>
        <button type="button" class="close" (click)="closeDataExportModal()">&times;</button>
      </div>
      <div class="modal-body export-modal-body">
        <div class="export-summary-strip">
          <div class="export-summary-pill"><strong>{{ exportDataSectionsCount }}</strong><span>sections</span></div>
          <div class="export-summary-pill"><strong>{{ trips.length }}</strong><span>trips</span></div>
          <div class="export-summary-pill"><strong>{{ loggedInDevices.length }}</strong><span>devices</span></div>
          <div class="export-summary-pill"><strong>{{ recentActivity.length }}</strong><span>activity items</span></div>
        </div>

        <div class="export-grid">
          <section class="export-card">
            <h6 class="export-card-title">Profile</h6>
            @for (row of exportProfileRows; track row.label) {
              <div class="export-row">
                <span class="export-row-label">{{ row.label }}</span>
                <span class="export-row-value">{{ row.value }}</span>
              </div>
            }
          </section>

          <section class="export-card">
            <h6 class="export-card-title">Notifications</h6>
            @for (row of exportNotificationRows; track row.label) {
              <div class="export-row">
                <span class="export-row-label">{{ row.label }}</span>
                <span class="export-row-value">{{ row.value }}</span>
              </div>
            }
          </section>

          <section class="export-card">
            <h6 class="export-card-title">Recent trips</h6>
            @if (exportTripPreview.length > 0) {
              @for (trip of exportTripPreview; track trip.key) {
                <div class="export-list-item">
                  <p class="export-list-title">{{ trip.title }}</p>
                  <p class="export-list-meta">{{ trip.meta }}</p>
                </div>
              }
            } @else {
              <p class="info-empty">No trips will be included yet.</p>
            }
          </section>

          <section class="export-card">
            <h6 class="export-card-title">Devices</h6>
            @if (exportDevicePreview.length > 0) {
              @for (device of exportDevicePreview; track device.key) {
                <div class="export-list-item">
                  <p class="export-list-title">{{ device.title }}</p>
                  <p class="export-list-meta">{{ device.meta }}</p>
                </div>
              }
            } @else {
              <p class="info-empty">No device history will be included yet.</p>
            }
          </section>
        </div>
      </div>
      <div class="modal-footer export-modal-footer">
        <button type="button" class="btn-outline-action" (click)="closeDataExportModal()">Close</button>
        <button type="button" class="btn-primary-action" (click)="downloadAccountData()">Download JSON</button>
      </div>
    </div>
  </div>
</div>
@if (isDataExportModalOpen) {
  <div class="modal-backdrop fade show export-modal-backdrop"></div>
}

<!-- Profile Modal -->
<div class="modal fade" id="buupassProfileModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content rounded-3">
      <form #profileForm="ngForm">
        <div class="modal-header">
          <h5 class="modal-title">Edit Profile</h5>
          <button id="closeProfile" type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body p-4">
          <div class="mb-3">
            <label class="form-label">First Name</label>
            <input type="text" class="form-control" name="first_name" [(ngModel)]="form.first_name" required>
          </div>
          <div class="mb-3">
            <label class="form-label">Last Name</label>
            <input type="text" class="form-control" name="last_name" [(ngModel)]="form.last_name" required>
          </div>
          <div class="mb-3">
            <label class="form-label">Email</label>
            <input type="email" class="form-control" name="email" [(ngModel)]="form.email">
          </div>
          <div class="mb-3">
            <label class="form-label">ID Number</label>
            <input type="text" class="form-control" name="id_number" [(ngModel)]="form.id_number">
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-primary-action" (click)="submitProfile()">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Phone Modal -->
<div class="modal fade" id="buupassPhoneModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content rounded-3">
      <div class="modal-header">
        <h5 class="modal-title">Add Mobile Number</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body p-4">
        <label class="form-label">Mobile Number</label>
        <div class="input-group">
          <span class="input-group-text">🇰🇪 +254</span>
          <input type="tel" class="form-control" [(ngModel)]="phoneNumber" placeholder="712345678" maxlength="9">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-primary-action" (click)="submitPhoneNumber()">Save</button>
      </div>
    </div>
  </div>
</div>

<!-- Email Modal -->
<div class="modal fade" id="buupassEmailModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content rounded-3">
      <div class="modal-header">
        <h5 class="modal-title">Add Email Address</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body p-4">
        <label class="form-label">Email</label>
        <input type="email" class="form-control" [(ngModel)]="emailInput" placeholder="you@example.com">
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-primary-action" (click)="submitEmail()">Save</button>
      </div>
    </div>
  </div>
</div>

<!-- Password Modal -->
<div class="modal fade" id="buupassPasswordModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content rounded-3">
      <div class="modal-header">
        <h5 class="modal-title">Change Password</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body p-4">
        <div class="mb-3">
          <label class="form-label">Current Password</label>
          <input [type]="showOldPassword ? 'text' : 'password'" class="form-control" [(ngModel)]="passwordForm.oldPassword" name="oldPassword" placeholder="Enter current password">
        </div>
        <div class="mb-3">
          <label class="form-label">New Password</label>
          <input [type]="showNewPassword ? 'text' : 'password'" class="form-control" [(ngModel)]="passwordForm.newPassword" name="newPassword" placeholder="Enter new password">
        </div>
        <div class="mb-3">
          <label class="form-label">Confirm New Password</label>
          <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control" [(ngModel)]="passwordForm.confirmPassword" name="confirmPassword" placeholder="Confirm new password">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-primary-action" (click)="submitPassword()">Update</button>
      </div>
    </div>
  </div>
</div>
